<template>
  <div class="rd-screen">
    <report-tools :copy="rows.length > 0" @copy="copyTable"></report-tools>

    <report-state v-if="loading" kind="loading"></report-state>
    <report-state
      v-else-if="!rows.length"
      icon="mdi-check-circle-outline"
      :title="emptyTitle"
      :text="emptyText"
    ></report-state>
    <company-desktop-taken-table
      v-else
      :sections="sections"
      :shifts="visibleShifts"
      :name-label="$t('meal')"
    ></company-desktop-taken-table>
  </div>
</template>

<script>
import CompanyReportTabTakenMeals from "@/components/company/reports/companyTabs/companyReportTabTakenMeals.vue";
import hasBarShifts from "@/components/report/shared/hasBarShifts";
import hasShiftSubtitle from "@/components/report/shared/hasShiftSubtitle";
import { copyText, rowsToTsv } from "@/components/report/desktop/copyTable";
import ReportState from "@/components/report/desktop/ReportState.vue";
import ReportTools from "@/components/report/desktop/ReportTools.vue";
import { hasPeriodRefetch } from "../../hasPeriodRefetch";
import { takenKpis, toTakenRow, toTakenSection, visibleTakenShifts } from "../../takenRows";
import CompanyDesktopTakenTable from "../CompanyDesktopTakenTable.vue";

/**
 * Preuzeti obroci firme na računaru: obroci izabranih firmi sa preuzeto / poručeno po smenama. Firme, smene,
 * period i pretragu čita iz zajedničke trake. Nasleđuje učitavanje, štampu i Excel iz starog taba.
 */
export default {
  name: "CompanyDesktopTakenMeals",
  extends: CompanyReportTabTakenMeals,
  mixins: [hasBarShifts, hasShiftSubtitle, hasPeriodRefetch("fetchMeals")],
  components: { ReportState, ReportTools, CompanyDesktopTakenTable },
  computed: {
    /** Obroci po abecedi (smene bez narudžbi se ne prikazuju). */
    rows() {
      const found = this.search
        ? this.customSearch(this.filteredMeals, [{ value: "name" }], this.search)
        : this.filteredMeals;
      return found
        .filter((meal) => meal.total > 0)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((meal, index) => toTakenRow(meal, `${meal.id || meal.name}-${index}`, meal.name));
    },
    sections() {
      return this.rows.length ? [toTakenSection("all", "", this.rows)] : [];
    },
    visibleShifts() {
      return visibleTakenShifts(this.selectedShifts, this.sections);
    },
    emptyTitle() {
      return this.search
        ? this.$t("report_mobile.no_results_for", { search: this.search })
        : this.$t("no_taken_meals_data");
    },
    emptyText() {
      return this.search ? "" : this.$t("report_desktop.empty_hint");
    },
    kpis() {
      return takenKpis((key) => this.$t(key), {
        sections: this.sections,
        showTaken: true,
        countLabel: this.$t("meals"),
        count: this.rows.length,
      });
    },
  },
  watch: {
    kpis: {
      handler(kpis) {
        this.$emit("kpis", this.rows.length ? kpis : []);
      },
      immediate: true,
    },
    loading: {
      handler(loading) {
        this.$emit("loading", loading);
      },
      immediate: true,
    },
  },
  methods: {
    async copyTable() {
      const headers = [this.$t("meal"), ...this.visibleShifts.map((shift) => this.$t(shift.label)), this.$t("total")];
      const rows = this.rows.map((row) => [
        row.name,
        ...this.visibleShifts.map((shift) => {
          const cell = row.cells[shift.id];
          return cell.ordered ? `${cell.taken}/${cell.ordered}` : "";
        }),
        `${row.taken}/${row.ordered}`,
      ]);
      const copied = await copyText(rowsToTsv(headers, rows));
      this.$emit("toast", this.$t(copied ? "report_desktop.copied" : "report_desktop.copy_failed"));
    },
  },
};
</script>
